export default __webpack_public_path__ + "static/media/Nunito-ExtraLight.1157587b.woff";